import React from "react";

export default function TabButton({ isActive, onClick, children, isDark }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center gap-3 py-10 px-16 relative transition-all duration-300 ${
        isActive
          ? isDark
            ? "border-b-[1.5px] border-white"
            : "border-b-[1.5px] border-black"
          : "border-b-[1.5px] border-transparent"
      }`}
    >
      <span
        className={`text-[14px] leading-[1.43em] tracking-[-2%] transition-all duration-300 ${
          isActive
            ? `font-medium ${isDark ? "text-white" : "text-black"}`
            : `font-regular ${isDark ? "text-[#CDCDCD]" : "text-[#5D5D5D]"}`
        }`}
      >
        {children}
      </span>
    </button>
  );
}
